module.exports = __webpack_public_path__ + "static/media/160307-MobileKickoff-Recap.003.1a2e1272.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/misc/160307-MobileKickoff-Recap/160307-MobileKickoff-Recap.003.png
// module id = 178
// module chunks = 0